import './detailItemList.scss'
import templateUrl from './detailItemList.html'

/**
 * Detail Item List component.
 *
 * List of resource items (properties) in a resource detail page.
 *
 * @example
 *   <tmr-detail-item-list items="[
 *     { label: 'SOME.TRANSLATION.KEY', value: 'some value' }
 *     { label: 'OTHER.TRANSLATION.KEY', value: 'some date value', filter: 'date', filterArgs: 'dd/MM/y hh:mm:ss:sss' }
 *   ]"></tmr-detail-item-list>
 *
 * @type {ngComponent}
 * @prop {array<object>} items The list of items. Each item has a `label` and a `value` property,
 *   and optionally `filter` and `filterArgs`.
 */
export const tmrDetailItemList = {
  ngType: 'component',
  templateUrl,
  bindings: {
    items: '<',
  },
}
